﻿import { createFileRoute } from "@tanstack/react-router";
import { EstoquesPage } from "@/paginas/pg_franquia/franquia-estoques-main";

export const Route = createFileRoute("/_authenticated/estoques")({
  head: () => ({
    meta: [
      { title: "Estoques — Milky Moo Palmares" },
      {
        name: "description",
        content: "Central de gestão de estoques: compras, insumos e entradas.",
      },
      { property: "og:title", content: "Estoques — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Central de gestão de estoques: compras, insumos e entradas.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: EstoquesPage,
});
